import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import DlGroupList from "./pages/dl_group/DlGroupList";
import ToLogin from "./pages/auth/ToLogIn";
import ToLogout from "./pages/auth/ToLogout";
import AdminPhotoSeries from "./pages/photo_series/AdminPhotoSeries";
import AdmStart from "./pages/common/AdmStart";
import AdminLayout from "./layout/AdminLayout";
import { useAuthCurrent } from "hooks/auth/auth_current";

export default function AdmApp() {
  const authCurrent = useAuthCurrent();
  const navigate = useNavigate();
  useEffect(() => {
    // console.log("authCurrent", authCurrent);
    if (!authCurrent || !authCurrent.un || authCurrent.un === "") {
      navigate("/l-in");
    }
  }, [authCurrent]);

  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="/" element={<AdmStart />} />
        <Route path="l-in" element={<ToLogin />} />
        <Route path="l-out" element={<ToLogout />} />
        <Route path="dl-group-li" element={<DlGroupList />} />
        <Route path="photo-ser-li" element={<AdminPhotoSeries />} />
      </Route>
    </Routes>
  );
}
